import { Menu, PanelLeft, X } from 'lucide-react';
import { useSidebarContext } from './SidebarContext';

export default function HeaderToggle({ isOpen, onClick }) {
  const { toggleCompact } = useSidebarContext();

  const handleClick = () => {
    // Sur les écrans larges, toggle le mode compact
    if (window.innerWidth >= 1024) {
      toggleCompact();
    } else {
      // Sur mobile, toggle l'ouverture/fermeture
      onClick();
    }
  };

  return (
    <button
      onClick={handleClick}
      className="relative z-50 flex h-7 w-7 items-center justify-center rounded-lg text-gray-500 hover:text-white transition-all duration-300 ease-in-out hover:bg-[#FF9800]"
      aria-label={isOpen ? 'Fermer le menu' : 'Ouvrir le menu'}
    >
      <PanelLeft size={20}/>
    </button>
  );
}
